export enum MoveType {
    Eots = 'eots',
    Lead = 'lead',
    Vacancy = 'vacancy',
}
